var React = require('react');

function IconPick (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"approved-signal_1_","data-name":"approved-signal (1)"},React.createElement("path",{"id":"Path_100","data-name":"Path 100","d":"M17.3,4.637,15.147,3.395,13.9,1.244H11.421L9.27,0,7.119,1.244H4.635L3.393,3.4,1.242,4.637V7.121L0,9.272l1.242,2.151v2.484l2.151,1.242L4.635,17.3H7.119L9.27,18.542,11.421,17.3H13.9l1.242-2.151L17.3,13.907V11.423L18.54,9.272,17.3,7.12V4.637ZM8.433,13.066a.9.9,0,0,1-1.255,0L4.468,10.355a.87.87,0,0,1,0-1.23l.718-.718a.87.87,0,0,1,1.23,0L7.806,9.8l4.318-4.318a.87.87,0,0,1,1.23,0l.718.718a.87.87,0,0,1,0,1.23Z","transform":"translate(0 -0.002)","fill":"currentColor"})));
}

IconPick.defaultProps = {"id":"match","width":"18.54","height":"18.54","viewBox":"0 0 18.54 18.54"};

module.exports = IconPick;

IconPick.default = IconPick;
